import React from 'react';
import { DragOverlay } from '@dnd-kit/core';

import ProjectCard from '@features/project-management-tools/components/ProjectCard';

const DragOverlayForKanban = ({ activeDragTask }) => {
	return (
		<DragOverlay>
			{activeDragTask ? (
				<div className="dragable-task-box" style={{ transform: 'translate(70px, 70px)' }}>
					<ProjectCard projectInfo={activeDragTask} isDragging={true} isDetailsPage={true} />
				</div>
			) : null}
		</DragOverlay>
	);
};

export default DragOverlayForKanban;
